<div class="flex flex-row flex-wrap">
  <div class="w-12">
    <p-confirmDialog
      #cd
      header="Confirmation"
      icon="fas fa-exclamation-triangle"
      rejectIcon="fas fa-times p-button-warning"
      rejectButtonStyleClass="p-button-danger"
      acceptIcon="fas fa-check"
      acceptButtonStyleClass="p-button-success"
      >
    </p-confirmDialog>
  </div>
  <div class="w-12">
    <h1>{{ title }}</h1>
    <div style="overflow-x: auto; min-width: 0; width: 100%;">
    <p-table
      #ads
      dataKey="id"
      [value]="pagedItems"
      [columns]="columns"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[25, 50, 100]"
      [loading]="loading"
      size="small"
      showGridlines="true"
      stripedRows="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [paginator]="true"
      [rows]="pageable.size"
      [totalRecords]="totalElements"
      [globalFilterFields]="filterFields"
      [resizableColumns]="true"
      columnResizeMode="fit"
      [globalFilterFields]="filterFields"
      [tableStyle]="{'min-width': '100%'}"
      sortMode="multiple"
      class="w-12"
      >
      <ng-template #caption>
        <div class="flex flex-row flex-wrap">
          <p-button-group class="w-2">
            <p-button pRipple icon="fas fa-file-csv" (click)="ads.exportCSV()" pTooltip="Save as CSV"
              tooltipPosition="bottom"/>
            <p-button pRipple icon="fas fa-file-excel" (click)="exportExcel()"
              severity="success" pTooltip="Save as XLS" tooltipPosition="bottom"/>
          </p-button-group>
          <!-- <p-inputgroup class="w-10">
          <p-inputGroupAddon>
            <i class="fas fa-search"></i>
          </p-inputGroupAddon>
          <span class="p-input-icon-left p-ml-auto">
            <i class="fas fa-search"></i>
            <input
              pInputText
              type="text"
              (input)="ads.filterGlobal($event, 'contains')"
              placeholder="Search"
              />
          </span> -->
        <!-- </p-inputgroup> -->
      </div>
    </ng-template>

    <ng-template #header>
      <tr>
        <th style="width: 3rem">
          <!--<p-tableHeaderCheckbox></p-tableHeaderCheckbox>-->
          Row
        </th>

        @for (column of columns; track column) {
          <th
            pResizableColumn
            [pSortableColumn]="column.field"
            >
            <div class="flex justify-content-between align-content-center">
              {{ column.header }}
              <p-sortIcon [field]="column.field"></p-sortIcon>
              @if (column.field === 'status') {
                <p-columnFilter
                  field="status"
                  matchMode="equals"
                  display="menu"
                  [showMatchModes]="false"
                  [showOperator]="false"
                  [showAddButton]="false"
                  >
                  <ng-template #filter let-value let-filter="filterCallback">
                    <p-select
                      [options]="statusOptions"
                      [ngModel]="value"
                      (onChange)="filter($event.value)"
                      (onClear)="filter(null)"
                      [showClear]="true"
                      placeholder="Any status"
                      class="w-full"
                      />
                  </ng-template>
                </p-columnFilter>
              }
              @if (column.field === 'visibility') {
                <p-columnFilter
                  field="visibility"
                  matchMode="equals"
                  display="menu"
                  [showMatchModes]="false"
                  [showOperator]="false"
                  [showAddButton]="false"
                  >
                  <ng-template #filter let-value let-filter="filterCallback">
                    <p-select
                      [options]="visibilityOptions"
                      [ngModel]="value"
                      (onChange)="filter($event.value)"
                      (onClear)="filter(null)"
                      [showClear]="true"
                      placeholder="Any visibility"
                      class="w-full"
                      />
                  </ng-template>
                </p-columnFilter>
              }
              @if (column.field === 'studyNativeId' || column.field === 'studyTitleDescription' || column.field === 'submitterName') {
                <p-columnFilter
                  type="text"
                  [field]="column.field"
                  display="menu"
                  [showMatchModes]="false"
                  [showOperator]="false"
                  [showAddButton]="false"
                  >
                  <ng-template #filter let-value let-filter="filterCallback">
                    <input
                      pInputText
                      type="text"
                      [ngModel]="value"
                      (ngModelChange)="filter($event)"
                      placeholder="Filter by {{ column.header }}"
                      class="w-full"
                      />
                  </ng-template>
                </p-columnFilter>
              }
            </div>
          </th>
        }
        <th class="sticky-actions">Actions</th>
      </tr>
    </ng-template>
    <ng-template
      #body
      let-rowData
      let-columns="columns"
      let-rowIndex="rowIndex"
      >
      <!--<tr class="p-selectable-row">-->
      <tr>
        <td style="width: 3rem">
          {{ rowIndex + 1 }}
          <!--<p-tableCheckbox [value]="rowData"></p-tableCheckbox>-->
        </td>
        @for (col of columns; track col) {
          <td><span class="p-column-title">{{ col.header }}</span>
            @if (col.filterType === 'object') {
              <div>
                {{ col.content(rowData[col.field]) | json }}
              </div>
            }
            @if (col.filterType === 'numeric') {
              <div>
                {{ col.content(rowData[col.field]) }}
              </div>
            }
            @if (col.filterType === 'date') {
              <div>
                {{ col.content(rowData[col.field]) | date: "short" }}
              </div>
            }
            @if (col.filterType === 'text') {
              <div>
                {{ col.content(rowData[col.field]) | ellipsis: 50 }}
              </div>
            }
          </td>
        }
        <td class="sticky-actions">
          <button
            pButton
            icon="fas fa-edit"
            class="edit-btn p-button p-button-primary mr-2"
            pTooltip="Edit"
            (click)="edit(rowData)"
          ></button>
          <button
            pButton
            icon="fas fa-times"
            class="delete-btn p-button p-button-danger mr-2"
            pTooltip="Delete"
            (click)="delete(rowData)"
          ></button>
          @if (rowData.status === 'SUBMITTED') {
            <button
              pButton
              icon="fas fa-file-import"
              class="import-review-btn p-button p-button-success mr-2"
              pTooltip="Import for review"
              (click)="startImport(rowData, false)"
            ></button>
            <button
              pButton
              icon="fas fa-rocket"
              class="import-publish-btn p-button p-button-success mr-2"
              pTooltip="Import & publish"
              (click)="startImport(rowData, true)"
            ></button>
          }
          @if (rowData.status === 'IN_REVIEW' || rowData.status === 'IN_CURATION') {
            <button
              pButton
              icon="fas fa-globe"
              class="publish-btn p-button p-button-help mr-2"
              pTooltip="Publish"
              (click)="publish(rowData)"
            ></button>
            <button
              pButton
              icon="fas fa-clipboard-check"
              class="curation-btn p-button p-button-warning mr-2"
              [pTooltip]="rowData.status === 'IN_CURATION' ? 'Unmark for curation' : 'Mark for curation'"
              (click)="toggleCuration(rowData)"
            ></button>
          }
          @if (rowData.status !== 'SUBMITTED' && rowData.status !== 'IN_PROGRESS') {
            <button
              pButton
              icon="fas fa-trash-arrow-up"
              class="unimport-btn p-button p-button-danger mr-2"
              pTooltip="Unimport"
              (click)="unimport(rowData)"
            ></button>
          }
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td [attr.colspan]="columns.length + 1">No Items found.</td>
      </tr>
    </ng-template>
  </p-table>
  </div>
</div>
</div>
